<template>
	<!-- 头部进度 -->
	<div class="cTconBox d-rn d-aic d-jcb">
		<!-- 左侧图片 -->
		<ul class="cTconBox-lftBox">
			<img src="../assets/img/comm/icon_logoLeft.png" >
		</ul>
		<!-- 右侧进度条 -->
		<div class="rgtJdBox d-rn d-aic d-jce">
			<ul v-for="(item,index) in 3" :key='index' :class="['rgtJdBox-itemUlBox','d-cw','d-aic','d-jcs','']">
				<!-- 上==进度 -->
				<li class="rgtJdBox-itemUlBox-topBox d-cw d-aic d-jcc">
					<!-- 横线 -->
					<p :style="{background:crtNum==(index+1)?'#ff7c7c':crtNum>(index+1)?'#ffd2d2':'#e1e1e1'}"
					class="rgtJdBox-itemUlBox-topBox-aline"></p>
					<!-- 圆形 -->
					<p 
					class="rgtJdBox-itemUlBox-topBox-acircular">{{index+1}}</p>
					<!-- 交界处圆形 -->
					<p v-show="[0,1].indexOf(index)>=0?true:false" 
					class="rgtJdBox-itemUlBox-topBox-aspot"></p>
				</li>
				<!-- 下文字 -->
				<li :class="[crtNum==(index+1)?'txtCrtClor':crtNum>(index+1)?'txtOldCreClor':'txtNoCrtClor','rgtJdBox-itemUlBox-btmTxt']">
					{{!index?'我的购物车':index==1?'填写核对订单信息':'成功提交订单'}}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	let _self;
	export default {
		name:"topBox",
		data() {
			return {
				
			}
		},
		props:{
			crtNum:{
				type:[String,Number],
				default:1
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			
		},
		// 方法集
		methods: {
			
		},
		// 组件集
		components:{

		},
		mounted() {
			// console.log('进度==接受到参数===',this.crtNum);
		},
		watch:{
			crtNum(val){
				// console.log('进度==接受到参数===',val);
			}
		},
		computed:{
		
		},
		// 过滤器
		filters:{
			
		},
		// 实例销毁
		destroyed(){
			
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style lang="scss">
	/* 组件总样式 */
	.cTconBox{
		width: 1200px;
		padding: 35px 0;
		box-sizing: border-box;
		margin: 0 auto;
		/* 左侧图片 */
		&-lftBox{
			width: 190px;
			height: 66px;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	/* 进度条 */
	.rgtJdBox{
		flex: 1;
		/* 每个item */
		&-itemUlBox{
			width: 254px;
			/* 头部信息 */
			&-topBox{
				width: 100%;
				height: 48px;
				position: relative;
				/* 横线 */
				&-aline{
					width: 100%;
					height: 8px;
					opacity: 1;
					background: #ff7c7c;
				}
				/* 圆 */
				&-acircular{
					
					width: 48px;
					height: 48px;
					background: #ff7c7c;
					border-radius: 50%;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%,-50%);
					text-align: center;
					line-height: 48px;
					
					font-size: 22px;
					font-weight: 400;
					color: #ffffff;
					letter-spacing: 1px;
				}
				/* 交界处圆点 */
				&-aspot{
					width: 8px;
					height: 8px;
					opacity: 1;
					background: #e62129;
					border-radius: 50%;
					position: absolute;
					z-index: 4;
					top: 50%;
					right: -4px;
					transform: translate(0,-50%);
				}
			}
			
			/* 底部文字 */
			&-btmTxt{
				margin-top: 5px;
				font-size: 22px;
				font-weight: 400;
				text-align: center;
				letter-spacing: 1px;
			}
		}
	}
	/* 当前进度===文字颜色 */
	.txtCrtClor{
		color: #ff7c7c;
	}
	/* 未到达进度===文字颜色 */
	.txtNoCrtClor{
		color: #e1e1e1;
	}
	/* 以前进度===文字颜色 */
	.txtOldCreClor{
		color: #ffd2d2;
	}
	
	
</style>
